module.exports = __webpack_public_path__ + "static/media/power-all1.908719a3.png";